import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Plant } from '../../shared/models/plant.model';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { PagedResponse } from "@models/response.model";
import { AppUtils } from "@app/shared/util/app.utils";
import * as _ from 'lodash';

/**
 * Service class for handling CRUD operations on {@link Plant} objects.
 */
@Injectable()
export class PlantService {
    static readonly API_PLANTS_BASE_PATH = `${environment.baseURL}/api/plants`;

    constructor(private http: HttpClient) {
    }

    getAllPlants(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<Plant>>(`${PlantService.API_PLANTS_BASE_PATH}`, {params: params});
    }

    createPlant(plant) {
        return this.http.post<Plant>(`${PlantService.API_PLANTS_BASE_PATH}`, this.getPlantCopy(plant));
    }


    updatePlant(plant) {
        const copyPlant = this.getPlantCopy(plant);
        return this.http.put<Plant>(`${PlantService.API_PLANTS_BASE_PATH}/${copyPlant.id}`, copyPlant);
    }

    deletePlant(plant) {
        return this.http.delete<Plant>(`${PlantService.API_PLANTS_BASE_PATH}/${plant.id}`);
    }

    updatePlantDocumentsLocation(plantId: number, newLocation: string, pathsToBeRemoved: string[], oldRootPath: string) {
        return this.http.put(`${PlantService.API_PLANTS_BASE_PATH}/${plantId}/documents-location`, {
            newLocation: newLocation, pathsToBeRemoved: pathsToBeRemoved, oldRootPath: oldRootPath
        });
    }

    getPlantCopy(plant) {
        const copyPlant: any = {
            id: plant.id,
            name: plant.name,
            description: plant.description,
            lines: _.map(plant.lines, 'id'),
            documentsLocation: plant.documentsLocation
        };
        return copyPlant;
    }

}
